import React from 'react'
import { buildLevel } from '../../../services/game.services'

export default class BaseLevelComponent extends React.Component {
    flashTimeout = null
    state = {
        answer: '?',
        wrongAnswer: false,
        flash: false,
    }
    componentWillMount() {
        this.generateLevel()
        document.addEventListener("keydown", this.onKeyPress)
    }
    componentWillUnmount() {
        clearTimeout(this.flashTimeout)
        document.removeEventListener("keydown", this.onKeyPress)
        window.removeEventListener("resize", this.updateDimensions)
    }

    componentDidMount() {
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions)

    }

    updateDimensions = (clear = false) => {
        if (clear === true) {
            this.setState({
                gameContainerWidth: 0,
                gameContainerHeight: 0
            })
        } else {
            if (this.refs.level) {
                this.setState({
                    gameContainerWidth: this.refs.level.parentNode.clientWidth,
                    gameContainerHeight: this.refs.level.parentNode.clientHeight
                })
            }
        }

    }

    onKeyPress = (event) => {
        if (event.key && !isNaN(event.key)) {
            let answer = this.state.answer && this.state.answer !== '?' ? this.state.answer : ''
            this.onUpdate(answer.concat(event.key))
        } else if (event.key === 'Enter') {
            if (this.state.answer) {
                this.onEnter(this.state.answer)
                this.onUpdate('')
            }
        } else if (event.key === 'Delete') {
            this.onUpdate('')
        } else if (event.key === 'Backspace') {
            if (this.state.answer) {
                let answer = this.state.answer && this.state.answer !== '?' ? this.state.answer : ''
                this.onUpdate(answer.slice(0, -1))
            }
        }
    }

    generateLevel = () => {
        const levelConfig = buildLevel(this.props.level)
        this.setState({ ...levelConfig })
    }
    onUpdate = (answer) => {
        if (!answer) {
            answer = '?'
        }
        this.setState({ answer })
    }
    onRoundFail = () => {
        this.flash()
    }
    onRoundComplete = () => {
        this.flash()
    }
    flash = () => {
        this.setState({ flash: true })
        this.flashTimeout = setTimeout(() => this.setState({ flash: false }), 200)
    }
    onRefresh = () => {
        this.generateLevel()
    }
}


// WEBPACK FOOTER //
// ./src/components/game/levels/base.levels.js